/**
 * T046/T124/T130: Root Route
 * TanStack Router root with error boundary and 404 handling
 */

import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { ErrorBoundary } from '@/components/common/error-boundary'
import { NotFoundPage } from '@/pages/not-found'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
})

function RootComponent() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}
